import HardDrinkImage1 from '../images/foodImages/hardDrink/HardDrink_img1.jpg';

const HardDrink = [
  { id: 1, name: '約翰走路X.R 21年蘇格蘭威士忌', price: 230, description: '', image: HardDrinkImage1 },
  { id: 2, name: '格蘭利威12年席桶', price: 280, description: '', image: HardDrinkImage1 },
  { id: 3, name: '西班牙星達姆', price: 320, description: '', image: HardDrinkImage1 },
  { id: 4, name: '西班牙 莫里茲無酒精啤酒', price: 350, description: '', image: HardDrinkImage1 },
  {
    id: 5,
    name: '西班牙 安柏精釀 IPA',
    price: 380,
    description: '',
    image: HardDrinkImage1,
  },
  { id: 6, name: '小精靈', price: 380, description: '', image: HardDrinkImage1 },
];

export default HardDrink;
